import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { setActiveSort } from "../../helpers/product";
import { Collapse } from "react-collapse";
import { Link } from "react-router-dom";

const ShopCategories = ({ categories, getSortParams }) => {
  //const [stateLista, setstateLista] = useState(global.aziendaID == 1? true : false);
  const [stateLista, setstateLista] = useState(false);
  const [categorySelected, setCategorySelected] = useState(
    JSON.parse(sessionStorage.getItem("filter"))?.category?.split("|")
  );
  const [refresh, setRefresh] = useState(true);

  const CambioStato = () => {
    if (stateLista) setstateLista(false);
    else setstateLista(true);
  };
  useEffect(() => {
    setCategorySelected(
      JSON.parse(sessionStorage.getItem("filter"))?.category?.split("|")
    );
    setRefresh(!refresh);
  }, [sessionStorage.getItem("filter")]);
  return (
    <div className="sidebar-widget">
      <div
        data-role="title"
        role="tab"
        aria-selected="false"
        aria-expanded="false"
        tabindex="-1"
        onClick={() => CambioStato()}
        style={{
          fontSize: "17px",
          color: "black",
          fontWeight: 600,
          cursor: "pointer",
          lineHeight: "30px",
        }}
      >
        <span
          class={
            stateLista
              ? "icon pe-7s-angle-down pull-right"
              : "icon pe-7s-angle-up pull-right"
          }
          data-role="icons"
          style={{ display: "inline-block" }}
        >
          {" "}
        </span>
        Categorie
      </div>
      {/*<div className="shopping-cart-btn btn-hover text-center" style={{ padding: "10px" }}>
        <a style={{ padding: "10px", border: "1px gray solid", display: "block", width: "100%" }} onClick={() => CambioStato()}  >Categorie</a>
      </div>*/}
      {/* <h4  <h4 className="btn btn-primary btn-xs" onClick={() => CambioStato()}>Marchi </h4>*/}

      <Collapse
        theme={{ collapse: "foo", content: "bar" }}
        isOpened={stateLista}
      >
        <div className="sidebar-widget-tag">
          {categories ? (
            <ul>
              <li>
                <div className="sidebar-widget-list-left">
                  <button
                    id="allCategories"
                    onClick={(e) => {
                      document
                        .querySelectorAll(".categories")
                        .forEach((element) =>
                          element.classList.remove("active")
                        );
                      getSortParams("category", "all", "+");
                      setActiveSort(e);
                    }}
                  >
                    <span className="checkmark" /> Tutte le categorie
                  </button>
                </div>
              </li>
              {categories.map((category, key) => {
                if (category === "") return;
                return (
                  category.length > 0 && (
                    <li key={key}>
                      <div className="sidebar-widget-list-left">
                        <button
                          className={
                            "categories " +
                            (categorySelected?.find((v) => category === v)
                              ? "active"
                              : "")
                          }
                          onClick={(e) => {
                            document
                              .querySelector("#allCategories")
                              .classList.remove("active");
                            if (e.currentTarget.classList.contains("active"))
                              getSortParams("category", category, "-");
                            else getSortParams("category", category, "+");
                            setActiveSort(e);
                          }}
                        >
                          {" "}
                          <span className="checkmark" id={key} /> {category}{" "}
                        </button>
                      </div>
                    </li>
                  )
                );
              })}
            </ul>
          ) : null}
        </div>
      </Collapse>
    </div>
  );
};

ShopCategories.propTypes = {
  categories: PropTypes.array,
  getSortParams: PropTypes.func,
};

export default ShopCategories;
